import {Selector} from "../mixins/dictionaries";
import {Modal, Popover} from "bootstrap";

import ReconnectingWebSocket from "reconnecting-websocket";
import CartoonEditor from "./cartoonEditor";
import RawEditor from "./rawEditor";
import Toolbar from "./toolbar";
import CartoonLinearMap from "./cartoonLinearMap";
import SequenceLinearMap from "./sequenceLinearMap";

import {
    bottomPadding,
    linearPreviewHeight,
    minHeightEditorContainer
} from "../mixins/constants";
import {constructRNAEncodedData, decodedRNA} from './utils';

import {loadStaticModal} from "../editor/utils";

export default class OligoEditor {
    constructor(settings, mediator) {
        this.settings = {
            ...settings
        }
        this.mediator = mediator;
        this.initData();
        this.initContainer();

        this.CartoonEditor = new CartoonEditor(this.settings, this.mediator);
        this.RawEditor = new RawEditor(this.settings, this.mediator);
        this.ToolbarOligo = new Toolbar(this.settings, this.mediator);
        this.SequenceLinearMap = new SequenceLinearMap(this.mediator);

        if (this.settings.hasSlots) {
            this.CartoonLinearMap = new CartoonLinearMap(this.mediator)
        }
    }

    initData() {
        this.userAgent = window.navigator.userAgent;
        this.protocolAnnotations = {
            context: {
                pk: null,
                type: null,
            },
            annotations: []
        };
    }

    initContainer() {
        let $mainContainer = document.querySelector(Selector.EDITOR);
        let $mainBoxContainer = $mainContainer.getBoundingClientRect();
        const editorContainerHeight = $mainBoxContainer.top + linearPreviewHeight + bottomPadding;
        const $containerEditors = $mainContainer.querySelector("#tabs div.card");
        // set minimum main container editor height
        const mainContainerHeight = Math.max(300, window.innerHeight - editorContainerHeight);

        $mainContainer.style.fontSize = "1rem";
        $mainContainer.style.height = mainContainerHeight + "px";
        $mainContainer.style.minHeight = minHeightEditorContainer + "px";

        $containerEditors.style.height = (mainContainerHeight) + "px";
    }

    connectWS(path) {
        const wsScheme = window.location.protocol === "https:" ? "wss" : "ws",
            wsPath = wsScheme + '://' + window.location.host + path;
        this.ws = new ReconnectingWebSocket(wsPath)
    }

    initWS() {
        this.connectedUsers = new Set();

        this.connectWS(this.settings.ws_path)

        const $protocol = document.getElementById('protocol')
        const contextId = $protocol ? $protocol.value : this.settings.contextId;

        this.ws.onopen = () => {
            const $staticModal = document.querySelector(Selector.MODAL);
            if (($staticModal || {}).classList.contains("show")) {
                const $modal = Modal.getInstance($staticModal);
                const $modalBackdrops = document.querySelectorAll('.modal-backdrop');
                $modalBackdrops.forEach(mb => {
                    mb.remove();
                })
                $modal.hide();
            }
            if (contextId)
                this.ws.send(JSON.stringify({
                    group_id: contextId,
                    group_type: this.settings.contextType
                }))
        }

        if ($protocol)
            $protocol.addEventListener('change', (event) => {
                this.setContextEditor($protocol.value, this.settings.contextType)
                if ($protocol.value)
                    this.ws.send(JSON.stringify({
                        group_id: $protocol.value,
                        group_type: this.settings.contextType
                    }))
            })

        this.ws.onmessage = (event) => {
            const message = JSON.parse(event.data);

            if (message?.data) {
                let decodedStructuredData, encodedData;
                let sourceData = {
                    "editable": this.settings.editable,
                    "slots": []
                };

                if (this.settings.hasSlots && message?.data) {
                    const structuredEncodedData = constructRNAEncodedData(message.data);
                    encodedData = structuredEncodedData.encodedData;
                    sourceData.slots = structuredEncodedData.encodedDataSlots;
                } else {
                    encodedData = message.data.encodings
                    sourceData = { ...sourceData, ...message.data };
                }

                decodedStructuredData = decodedRNA(encodedData, this.settings.type_map);

                if (decodedStructuredData?.sequence && decodedStructuredData.sequence.length) {
                    this.CartoonEditor.setData(decodedStructuredData, sourceData);
                    this.RawEditor.setData(decodedStructuredData, sourceData);

                    this.ToolbarOligo.setData(decodedStructuredData, sourceData);
                    this.SequenceLinearMap.setData(decodedStructuredData, sourceData);

                    if (this.settings.hasSlots) {
                        this.CartoonLinearMap.setData(decodedStructuredData, sourceData);
                    }
                } else if (message.data.annotations) {
                }
            }
            if (message?.msg) {
                //appendToast(this.$toastContainer, result.msg)
            }


            if (message.users) {
                let $connectedUsers = document.getElementById('connectedUsers');
                for (let [key, user] of Object.entries(message.users)) {
                    if (!this.connectedUsers.has(key)) {
                        let userEl = document.createElement('a')
                        userEl.href = '#'
                        userEl.dataset.bsToggle = 'popper'
                        userEl.dataset.bsTrigger = 'hover'
                        userEl.dataset.bsContent = user.full_name
                        userEl.className = "btn btn-light border-0 rounded-circle p-1"
                        let gravatarImg = document.createElement('img')
                        gravatarImg.className = 'rounded-circle'
                        gravatarImg.src = `${user.gravatar_url}?s=30&d=identicon&r=g`
                        gravatarImg.alt = user.email
                        userEl.appendChild(gravatarImg)
                        new Popover(userEl)
                        $connectedUsers.appendChild(userEl)

                        this.connectedUsers.add(key)
                    }
                }
            }
        };

        this.ws.onerror = (error) => {
        };

        this.ws.onclose = () => {
            setTimeout(() => {
                loadStaticModal();
            }, 1000);
        };
    }
}